import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightPipe implements PipeTransform {
  transform(value: string, args: string[] | string): string {
    if (!args.length) {
      return value;
    }
    const pattern = Array.isArray(args)
      ? args
        .filter(arg => !!arg)
        .map(this.escapeRegex)
        .join('|')
      : this.escapeRegex(args);
    const regex = new RegExp(pattern.concat('|<[^>]*>'), 'gi');
    return value.replace(regex, match =>
      /<[^>]*>/g.test(match)
        ? match
        : `<span class="highlight">${match}</span>`
    );
  }

  private escapeRegex(word: string) {
    return word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
}
